import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePage } from '../../core/api/hooks/usePages';
import { MainLayout } from '../../core/layouts/MainLayout';

export const ContentPage = () => {
    const { slug } = useParams<{ slug: string }>();
    const { data: page, isLoading, error } = usePage(slug || '');
    const { i18n } = useTranslation();

    if (isLoading) {
        return (
            <MainLayout>
                <div className="min-h-screen flex items-center justify-center bg-surface">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
                </div>
            </MainLayout>
        );
    }

    if (error || !page) {
        return (
            <MainLayout>
                <div className="min-h-screen flex flex-col items-center justify-center bg-surface text-slate-500">
                    <h1 className="text-4xl font-bold mb-4">404</h1>
                    <p>Page not found</p>
                    <a href="/" className="mt-4 text-secondary hover:underline">Go Home</a>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div className="min-h-screen bg-surface flex flex-col">
                <div className="container mx-auto px-4 py-16 max-w-4xl flex-grow mt-20">
                    <h1 className="text-4xl md:text-5xl font-bold mb-8 text-secondary font-display border-b border-slate-200 pb-6">
                        {page.title}
                    </h1>

                    <div
                        className="prose prose-lg prose-slate max-w-none prose-headings:font-display prose-headings:text-secondary prose-a:text-primary hover:prose-a:text-primary-dark"
                        dangerouslySetInnerHTML={{ __html: page.content || '' }}
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                    />
                </div>
            </div>
        </MainLayout>
    );
};
